import { makeVar } from '@apollo/client';

export const defaultFinancialProductRuleCommission = {
  financialProductRuleCommissionId: null,
  financialProductRuleId: null,
  readOnlyYN: false,
  commissionId: null,
  commissionName: '',
  commissionDefaultPercent: 0,
  commissionDefaultValue: 0,
  assignToRoleId: null,
  assignToRoleName: '',
  appliedToId: null,
  appliedToName: '',
  calculationMethodId: null,
  calculationMethodName: '',
  implicit: false,
  mandatory: false,
  usesPercent: true,
  usesValue: true
  };

export const financialProductRuleCommissionModalVar = makeVar({ open: false, item: defaultFinancialProductRuleCommission });
